<template>
    <div class="vipPage">
        <v-header ref="headerObj"></v-header>
        <div class="bgImg">
            <div class="product-div">
                <div class="product-div-dom">
                    <h3 class="h3_title">立即开通VIP 享更多特权</h3>
                    <div class="product_list_box" v-if="vipPrice != null">
                        <div :class="[productType == 1? 'product_list_box_item select':'product_list_box_item']" @click="productType = 1">
                            <p class="item_title">1个月会员</p>
                            <div class="item_price_dom">
                                <span class="red">¥{{vipPrice[0].price}}</span>
                                <span class="grey">¥99</span>
                            </div>
                        </div>
                        <div :class="[productType == 2? 'product_list_box_item select':'product_list_box_item']" @click="productType = 2">
                            <p class="item_title">3个月会员</p>
                            <div class="item_price_dom">
                                <span class="red">¥{{vipPrice[1].price}}</span>
                                <span class="grey">¥267</span>
                            </div>
                        </div>
                        <div :class="[productType == 3? 'product_list_box_item select':'product_list_box_item']" @click="productType = 3">
                            <p class="item_title">1年会员</p>
                            <div class="item_price_dom">
                                <span class="red">¥{{vipPrice[2].price}}</span>
                                <span class="grey">¥792</span>
                            </div>
                            <img class="imgClass" src="https://zyprogram.xinchacha.com/xiansuo/pc/tui.png" alt="" srcset="">
                        </div>
                    </div>
                    <div class="pay_btn" @click="goPay()">立即开通</div>
                </div>
            </div>
        </div>

        <div class="vipPage_body">
            <div class="vipPage_body_dom">
                <table class="tableClass" border="0" cellspacing="" cellpadding="">
                    <tr class="blue">
                        <td>会员权益</td>
                        <td class="member">普通会员</td>
                        <td class="member">包年会员</td>
                    </tr>
                    <tr class="white">
                        <td class="one">
                            <p class="title">推广搜索</p>
                            <p class="title_twe">客户线索覆盖四大搜索推广平台</p>
                        </td>
                        <td class="center">20次/小时</td>
                        <td class="center">不限次</td>
                    </tr>
                    <tr class="grey">
                        <td class="one">
                            <p class="title">推广公司列表</p>
                            <p class="title_twe">浏览推广公司查询的列表</p>
                        </td>
                        <td class="center">5条/次</td>
                        <td class="center">2500条/次</td>
                    </tr>
                    <tr class="white">
                        <td class="one">
                            <p class="title">推广详情列表</p>
                            <p class="title_twe">浏览推广关键词查询的列表</p>
                        </td>
                        <td class="center">9次/小时</td>
                        <td class="center">2500条/次</td>
                    </tr>
                    <tr class="grey">
                        <td class="one">
                            <p class="title">新增推广公司</p>
                            <p class="title_twe">浏览有推广的公司</p>
                        </td>
                        <td class="center">9次/小时</td>
                        <td class="center">2500条/次</td>
                    </tr>
                    <tr class="white">
                        <td class="one">
                            <p class="title">联系方式详情</p>
                            <p class="title_twe">一键查看企业的联系方式详情</p>
                        </td>
                        <td class="center">9次/小时</td>
                        <td class="center">2500条/次</td>
                    </tr>
                    <tr class="grey">
                        <td class="one">
                            <p class="title">企业推广详情</p>
                            <p class="title_twe">推广平台、推广记录、推广关键词</p>
                        </td>
                        <td class="center">列表可浏览数量</td>
                        <td class="center">不限次</td>
                    </tr>
                </table>
            </div>
        </div>
        <v-modular-five></v-modular-five>
        <v-footer></v-footer>

        <el-dialog title="立即支付" :visible.sync="paywin" width="560px" :before-close="handleClose">
            <div class="alert-box">
                <div class="jieshao_bix">
                    <p><span>购买账号：</span><span>{{ userId }}</span></p> 
                    <p><span>套餐类型：</span><span>{{ vipPrice[productType-1].name }}</span></p> 
                </div>
                <div class="qian_div">
                    实付金额：
                    <font>￥{{ vipPrice[productType-1].price }}</font>
                </div>
                <div class="zfFun_box">
                    <div :class="showData.code == 1 ? 'zf_box click' : 'zf_box'" @click="zfChengeFn(1)">
                        <img src="https://zyprogram.xinchacha.com/assets/img/addQiye/weixin-icon.png"/>
                            微信支付
                        <img class="dui" src="https://zyprogram.xinchacha.com/assets/img/addQiye/duigou.png"/>
                    </div>
                    <div :class="showData.code == 2 ? 'zf_box click' : 'zf_box'" @click="zfChengeFn(2)">
                        <img src="https://zyprogram.xinchacha.com/assets/img/addQiye/zfb-icon.png"/>
                            支付宝支付
                        <img class="dui" src="https://zyprogram.xinchacha.com/assets/img/addQiye/duigou.png"/>
                    </div>
                </div>
                
                <div class="erweima_box">
                    <div class="erweima_img_box" ref="alipayWap">
                        <div id="QRCode"></div>
                        <div class="erweima_title">
                            <img src="https://zyprogram.xinchacha.com/assets/img/addQiye/erwei.png"/>
                            <span>扫一扫继续付款</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import vHeader from './common/header.vue';
import vFooter from './common/footer.vue'
import QRCode from "qrcodejs2"; //引入生成二维码插件
export default {
    data(){
        return{
            productType:3,
            vipPrice:null,
            paywin:false,
            showData:{
                code: 2,
                count: 1,
                setmealId: '1',
                where: "1"
            },
            userId:'',
            pcBtnType:0,
            jiantingType:0
        }
    },
    components:{
        vHeader,
        vFooter
    },
    methods:{
        getzhifu(){
            this.getRequest('api/pay/clueQueryOrder').then((res)=>{
                var data = res.data;
                if (data == 'success') {
                    this.$message.success("支付成功");
                    this.jiantingType = 0;
                    this.paywin = false;
                    this.setToken();
                }else{
                    if (this.jiantingType != 0) {
                        setTimeout(this.getzhifu,1000)
                    }
                }
            })
        },
        setToken(){
            var data = {
				username:localStorage.getItem('userId')
			};
            this.postfromRequest('api/user/CompelRefreshToken',data).then(res=>{
                var data = res.data;
				if(data.status == 200){
                    localStorage.setItem("token",data.obj.jwt);
					localStorage.setItem("clueVip",data.obj.IS_CLUE_VIP);
				}
            })
        },
        pcPayFn(){
            var _this = this;
            this.postRequest('api/order/clue/createClueOrder',this.showData).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.QRCodeMsg(data.obj);
                    if (_this.jiantingType == 0) {
                        _this.jiantingType = 1;
                        _this.getzhifu()
                    };
                }
            })
        },
        /**
         * 二维码
         */
        QRCodeMsg(val) {
            document.getElementById('QRCode').innerHTML = "";
            new QRCode('QRCode', {
                width: 140,
                height: 140,
                text: val, // 二维码地址
                colorDark: '#000',
                colorLight: '#fff'
            });
            this.pcBtnType = 1;
        },
        zfChengeFn(value){
            this.showData.code = parseInt(value);
            this.pcPayFn();
        },
        handleClose(){
            var _this = this;
            this.$confirm('确认关闭？').then(_ => {
                document.getElementById('QRCode').innerHTML="";
                _this.pcBtnType = 0;
                _this.jiantingType = 0;
                _this.paywin = false;
            }).catch(_ => {});
        },
        getOrderPrice(){
            var _this = this;
            this.getRequest('api/order/clue/setMealByRoleIsFive',{}).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.vipPrice = data.obj;
                };
            })
        },
        goPay(){
	        var userId = localStorage.getItem('userId');
            if (userId == null) {
                this.$refs.headerObj.openProp();
            } else {
                this.userId = localStorage.getItem('userId');
                var thisData = this.vipPrice[this.productType-1];
                console.log(thisData)
                var payData = {
                    code: 2,
                    count: 1,
                    setmealId: thisData.setmealId,
                    where: "1"
                };
                this.showData = payData
                this.paywin = true;
                this.pcPayFn();
            }
        }
    },
    mounted(){
        this.getOrderPrice()
    }
}
</script>
<style lang="scss" scoped>
#QRCode{
    margin: 10px auto;
    display: flex;
    justify-content: center;
}
.vipPage{
    width: 100%;
    height: auto;
}
.bgImg{
    width: 100%;
    height: 490px;
    position: relative;
    background-image: url('https://zyprogram.xinchacha.com/xiansuo/pc/vipBg.png');
    background-size: 100% 100%;
    >div.product-div{
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        >div.product-div-dom{
            height: auto;
            margin: 0 auto;
            @media screen and (max-width: 1400px){
                width: 960px;
            }
            @media screen and (min-width: 1400px){
                width: 1200px;
            }
            >.h3_title{
                width: 100%;
                height: auto;
                font-size: 40px;
                color: #FFFFFF;
                font-weight: 400;
                text-align: center;
                margin-top: 50px;
                margin-bottom: 40px;
                cursor: default;
            }
            >div.product_list_box{
                width: 100%;
                height: auto;
                display: flex;
                justify-content: space-between;
                >div.product_list_box_item{
                    width: 31%;
                    height: auto;
                    background: #FFFFFF;
                    border-radius: 10px;
                    padding-top: 36px;
                    padding-bottom: 36px;
                    position: relative;
                    box-sizing: border-box;
                    >p.item_title{
                        width: 100%;
                        height: auto;
                        font-size: 30px;
                        font-weight: 400;
                        color: #333333;
                        text-align: center;
                        cursor: default;
                    }
                    >div.item_price_dom{
                        width: 100%;
                        height: 50px;
                        margin-top: 20px;
                        display: flex;
                        justify-content: space-evenly;
                        cursor: default;
                        .red{
                            color: #FF0000;
                            font-weight: 500;
                            font-size: 40px;
                            line-height: 50px;
                        }
                        .grey{
                            font-size: 22px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 64px;
                        }
                    }
                    >img.imgClass{
                        width: 60px;
                        position: absolute;
                        top: -5px;
                        left: -5px;
                    }
                }
                
                >div.product_list_box_item.select{
                    background-image: url('https://zyprogram.xinchacha.com/xiansuo/pc/select.png');
                    background-repeat: no-repeat;
                    background-position: 102% 104%;
                    background-size: 60px auto;
                    background-color: #FFF7DF;
                    border: 4px solid #0C6EE5;
                }
            }
            >div.pay_btn{
                width: 404px;
                height: 73px;
                line-height: 73px;
                font-size: 28px;
                font-weight: 600;
                color: #FFFFFF;
                background: #FC6500;
                border-radius: 8px;
                text-align: center;
                margin: 40px auto 0;
                cursor: default;
            }
        }
        
    }
}
.vipPage_body{
    width: 100%;
    height: auto;
    background-color: #F0F2F5;
    padding-top: 72px;
    padding-bottom: 72px;
    >div.vipPage_body_dom{
        height: auto;
        margin: 0 auto;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >table.tableClass{
            width: 100%;
            height: auto;
            background-color : #ECF6FF;
            cursor: default;
            >tr.blue{
                background-color : #ECF6FF;
                color: #4872D8;
                text-align: center;
                height: 80px;
                font-size: 26px;
                font-weight: 500;
                cursor: default;
                >td.member{
                    width: 28%;
                }
            }
            >tr.white{
                height: 130px;
                background-color : #fff;
                color: #666666;
                >td.center{
                    font-size: 22px;
                    color: #666666;
                    text-align: center;
                }
                >td.one{
                    color: #666666;
                    padding-left: 50px;
                    box-sizing: border-box;
                    p.title{
                        font-size: 22px;
                        font-weight: bold;
                        margin-bottom: 12px;
                    }
                    p.title_twe{
                        font-size: 22px;
                    }
                }
            }
            >tr.grey{
                height: 130px;
                background-color : #F9F9F9;
                color: #666666;
                >td.center{
                    font-size: 22px;
                    color: #666666;
                    text-align: center;
                }
                >td.one{
                    color: #666666;
                    padding-left: 50px;
                    box-sizing: border-box;
                    p.title{
                        font-size: 22px;
                        font-weight: bold;
                        margin-bottom: 12px;
                    }
                    p.title_twe{
                        font-size: 22px;
                    }
                }
            }
        }
    }
}


/**
支付弹窗
*/
.alert-box {
    width: 100%;
    height: auto;
}
.alert-box .jieshao_bix {
    width: 100%;
    /* height: 110px; */
    background-color: #f6f6f6;
    padding: 10px 20px;
    box-sizing: border-box;
    cursor: default;
}
.myps {
    width: 54%;
    height: 2px;
    background: #8a4400;
    margin-top: 8px;
    margin-left: 19.5px;
}
.mypst {
    width: 54%;
    height: 2px;
    background: #8a4400;
    margin-top: 8px;
    margin-left: 14px;
}
.alert-box .jieshao_bix p {
    width: 100%;
    height: auto;
    display: flex;
    font-size: 16px;
    color: #333333;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
}

.zfFun_box {
    width: 100%;
    height: auto;
    display: flex;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #ffffff;
    flex-direction: row;
    justify-content: space-around;
}
.zfFun_box .zf_box {
    width: auto;
    height: auto;
    line-height: 30px;
    cursor: default;
    padding: 4px 14px;
    box-sizing: border-box;
    border: 1px solid #eeeeee;
    position: relative;
}
.zfFun_box .zf_box .dui {
    display: none;
    position: absolute;
    right: -18px;
    bottom: -8px;
}
.my-f {
    font-weight: 700 !important;
}
.zfFun_box .zf_box.click {
    border: 1px solid #d81e06;
}
.zfFun_box .zf_box.click .dui {
    display: block;
}
.zfFun_box .zf_box img {
    width: 30px;
    height: auto;
    vertical-align: middle;
    margin-right: 10px;
}

.erweima_box {
    width: 100%;
    height: auto;
    padding-top: 30px;
    padding-bottom: 30px;
    box-sizing: border-box;
    background-color: #ffffff;
}
.erweima_img_box {
    width: 170px;
    height: 200px;
    margin: 0 auto;
    border: 1px solid #eeeeee;
    position: relative;
}
.erweima_img_box .erweima_title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #eeeeee;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    cursor: default;
}
.erweima_img_box .erweima_title img {
    vertical-align: middle;
}
.qian_div {
    width: 100%;
    height: 59px;
    line-height: 59px;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #f7f7f7;
    background-color: #ffffff;
    font-size: 14px;
    color: #000;
    cursor: default;
}
.qian_div font {
    font-size: 20px;
    color: #e60012;
}
/**
支付结束
*/


.erweima{
    width: 200px;
    height: 200px;
    margin: 20px auto;
    border: 1px solid #ccc;
    position: relative;
    .erweimaBtn{
        width: 100%;
        height: 200px;
        background-color: rgba($color: #000000, $alpha: 0.3);
        position: absolute;
        top: 0;
        left: 0;
        font-size: 18px;
        color: #fff;
        border: none;
    }
}
.erweimaBtn.showBtn{
    display: none;
}
.erweima:hover .erweimaBtn.showBtn{
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/vipPage.vue